function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelctMultiples(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.422,
    height: 15.103,
    viewBox: "0 0 19.422 15.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6543"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 974",
    d: "M-6337.608-9237.791c-2.355.038-2.179-1.738-2.179-1.738s-.022-5.9 0-7.508 1.783-1.783 1.783-1.783h6.957s2.553-.242 2.531 1.783",
    transform: "translate(6340.297 9249.335)",
    style: {
      strokeLinecap: "round",
      stroke: "#ffa539",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 975",
    d: "M-6325.552-9238.829s-.008.289 0 2.225-2.344 1.867-2.344 1.867-3.527.014-6.314 0-2.434-2.224-2.434-2.224v-6.939a1.908 1.908 0 0 1 1.665-1.9h7.165s2.27-.161 2.262 1.9",
    transform: "translate(6340.774 9249.335)",
    style: {
      stroke: "#14a4c2",
      strokeLinecap: "round",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Tick Mark"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 497",
    d: "m1760.318 2784.781 3.239 3.389 6.329-6.891",
    transform: "translate(-1751.665 -2776.435)",
    style: {
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: "1.7px",
      strokeLinecap: "round",
      stroke: "#ffa539"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelctMultiples);
export default __webpack_public_path__ + "static/media/SelctMultiples.6c60ec2adc579e5de179e3c6721c8754.svg";
export { ForwardRef as ReactComponent };